import React, { createContext, useContext, ReactNode } from 'react';

import { VariablePluginOption } from '../hooks';

export const VariablePluginCtx = createContext<{
  options: VariablePluginOption[];
}>({ options: [] });

export const VariablePluginProvider = ({
  children,
  options = [],
}: {
  children: ReactNode;
  options?: VariablePluginOption[];
}) => {
  return (
    <VariablePluginCtx.Provider
      value={{
        options,
      }}
    >
      {children}
    </VariablePluginCtx.Provider>
  );
};

export const useVariablePluginCtx = () => {
  return useContext(VariablePluginCtx);
};
